import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function PaloAltoCortexXDRConnectForm({ onSubmit, guideMode }) {
  const [showAPIKey, setShowAPIKey] = useState(false);
  const handleClickShowAPI = () => setShowAPIKey(!showAPIKey);
  const handleMouseDownAPI = () => setShowAPIKey(!showAPIKey);

  const formInitialValues = {
    api_key: "",
    api_url: "",
    key_id: "",
  };
  const formCheckoutSchema = yup.object().shape({
    api_key: yup.string().required("required"),
    api_url: yup.string().required("required"),
    key_id: yup.string().required("required"),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="key_id"
                label="API Key ID"
                value={values.key_id}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.key_id && !!errors.key_id}
                helperText={touched.key_id && errors.key_id}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={showAPIKey ? "text" : "password"}
                name="api_key"
                autoComplete="off"
                label="API Key"
                value={values.api_key}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.api_key && !!errors.api_key}
                helperText={touched.api_key && errors.api_key}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle key visibility"
                        onClick={handleClickShowAPI}
                        onMouseDown={handleMouseDownAPI}
                      >
                        {showAPIKey ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                type={"text"}
                name="api_url"
                label="API URL"
                value={values.api_url}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.api_url && !!errors.api_url}
                helperText={touched.api_url && errors.api_url}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
